"use client";
import Image from "next/image";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";

import banner1 from "@/public/pm-suryaghar.jpg";
import banner2 from "@/public/banner-img2.png";
import banner3 from "@/public/banner-img3.png";
import { useEffect, useState } from "react";

export default function Banner() {
  const banners = [banner1, banner2, banner3];
  const [api, setApi] = useState(null);

  // Auto-scroll every 4 seconds
  useEffect(() => {
    if (!api) return;

    const interval = setInterval(() => {
      api.scrollNext();
    }, 4000);

    return () => clearInterval(interval);
  }, [api]);

  return (
    <div className="relative w-full h-auto py-12 overflow-hidden">
      <Carousel
        setApi={setApi}
        opts={{
          align: "center",
          loop: true,
          duration: 60,
        }}
        className="w-full h-full"
      >
        <CarouselContent>
          {banners.map((img, index) => (
            <CarouselItem
              key={index}
              withPadding={false}
              className="basis-full w-full h-full flex-shrink-0"
            >
              <div className="relative w-full h-[165px] md:h-[320px]">
                <Image
                  src={img}
                  alt={`Banner ${index + 1}`}
                  fill
                  priority
                  className="w-full h-full"
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  );
}
